export enum ClasseVitesse {
    N1 = 1,
    N3 = 3,
    N5 = 5,
    N4 = 4,
    N2 = 2,
    N6 = 6
}
